module.exports = __webpack_public_path__ + "static/confetti-c39f25567ce5428f906464b12b482f39.png";